import type { SVGProps } from 'react'

type IconName =
  | 'sun'
  | 'play'
  | 'pause'
  | 'step-forward'
  | 'step-back'
  | 'today'
  | 'external'
  | 'pulse'
  | 'spark'
  | 'shield'
  | 'target'
  | 'ruler'
  | 'speed'
  | 'globe'

const ICON_PATHS: Record<IconName, string> = {
  sun: 'M12 6.75a5.25 5.25 0 1 1-5.25 5.25A5.25 5.25 0 0 1 12 6.75Zm0-4.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Zm0 17.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm9-6.75a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 .75.75Zm-16.5 0a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1 0-1.5H3.75a.75.75 0 0 1 .75.75Zm14.396 7.146a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.061a.75.75 0 0 1 1.06 0Zm-12.732-12.73a.75.75 0 0 1 0 1.06l-1.061 1.06a.75.75 0 0 1-1.06-1.06l1.06-1.06a.75.75 0 0 1 1.061 0Zm12.732 0 1.06-1.06a.75.75 0 0 1 1.061 1.06l-1.06 1.06a.75.75 0 1 1-1.061-1.06ZM6.354 18.103a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 0 1-1.061-1.061l1.06-1.06a.75.75 0 0 1 1.061 0Z',
  play: 'M7.5 5.25a1.5 1.5 0 0 1 2.219-1.317l8.25 4.75a1.5 1.5 0 0 1 0 2.634l-8.25 4.75A1.5 1.5 0 0 1 7.5 14.75Z',
  pause: 'M8.25 5.25A.75.75 0 0 1 9 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75Zm6 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75Z',
  'step-forward': 'M5.25 6.75a1.5 1.5 0 0 1 2.219-1.32l5.531 3.187V6.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 .75.75v10.5A.75.75 0 0 1 15 18h-1.25a.75.75 0 0 1-.75-.75v-1.867l-5.531 3.187A1.5 1.5 0 0 1 5.25 17.25Z',
  'step-back': 'M18.75 6.75a1.5 1.5 0 0 0-2.219-1.32L11 8.616V6.75a.75.75 0 0 0-.75-.75H9a.75.75 0 0 0-.75.75v10.5A.75.75 0 0 0 9 18h1.25a.75.75 0 0 0 .75-.75v-1.867l5.531 3.187A1.5 1.5 0 0 0 18.75 17.25Z',
  today: 'M7.5 4.5a1 1 0 1 0-2 0V5A2.5 2.5 0 0 0 3 7.5v9A2.5 2.5 0 0 0 5.5 19h11a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 5V4.5a1 1 0 1 0-2 0V5h-7Zm0 5.25h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5Zm0 4.5h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5Z',
  external: 'M15.75 3a.75.75 0 0 0 0 1.5h2.69l-7.72 7.72a.75.75 0 1 0 1.06 1.06l7.72-7.718V8.25a.75.75 0 1 0 1.5 0V3.75A.75.75 0 0 0 20.25 3Z M5.25 5.25A2.25 2.25 0 0 0 3 7.5v11.25A2.25 2.25 0 0 0 5.25 21h11.25A2.25 2.25 0 0 0 18.75 18.75v-5.25a.75.75 0 0 0-1.5 0v5.25a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 0 0-1.5Z',
  pulse: 'M4.5 12.75h3l1.5-4.5 3 9 2.25-6h4.5',
  spark: 'M12 2.25a.75.75 0 0 1 .674.419l1.591 3.182 3.513.512a.75.75 0 0 1 .415 1.279l-2.542 2.476.6 3.493a.75.75 0 0 1-1.088.791L12 12.96l-3.163 1.686a.75.75 0 0 1-1.089-.79l.6-3.494-2.543-2.476a.75.75 0 0 1 .415-1.279l3.514-.512 1.59-3.182A.75.75 0 0 1 12 2.25Z',
  shield:
    'M12 2.25c-.4 0-.79.09-1.15.26l-6 2.8a1.5 1.5 0 0 0-.85 1.35v4.39c0 4.42 2.99 8.39 7.27 9.64.45.13.94.13 1.39 0 4.28-1.25 7.27-5.22 7.27-9.64V6.66a1.5 1.5 0 0 0-.85-1.35l-6-2.8A2.5 2.5 0 0 0 12 2.25Zm0 2.13 5.25 2.45v4a8.25 8.25 0 0 1-5.25 7.53A8.25 8.25 0 0 1 6.75 10.8v-4Z',
  target:
    'M12 4.5a7.5 7.5 0 1 0 7.5 7.5A7.5 7.5 0 0 0 12 4.5Zm0 3a4.5 4.5 0 1 1-4.5 4.5A4.5 4.5 0 0 1 12 7.5Zm0 3a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 12 10.5Z',
  ruler:
    'M4.5 6.75A2.25 2.25 0 0 1 6.75 4.5h10.5A2.25 2.25 0 0 1 19.5 6.75v10.5A2.25 2.25 0 0 1 17.25 19.5H6.75A2.25 2.25 0 0 1 4.5 17.25ZM7.5 9.75h1.5a.75.75 0 0 0 0-1.5H7.5a.75.75 0 0 0 0 1.5Zm3 0h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5Zm3 0h1.5a.75.75 0 0 0 0-1.5H13.5a.75.75 0 0 0 0 1.5Zm-6 3h1.5a.75.75 0 0 0 0-1.5H7.5a.75.75 0 0 0 0 1.5Zm3 0h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5Zm3 0h1.5a.75.75 0 0 0 0-1.5H13.5a.75.75 0 0 0 0 1.5Z',
  speed:
    'M4.5 18a7.5 7.5 0 1 1 13.08-4.62l1.3 1.3a.75.75 0 1 1-1.06 1.06l-1.07-1.07A6 6 0 1 0 12 18a.75.75 0 0 1 0 1.5A7.5 7.5 0 0 1 4.5 18Zm7.5-12a.75.75 0 0 1 .75.75v4.19l1.9 1.9a.75.75 0 1 1-1.06 1.06l-2.13-2.13A.75.75 0 0 1 11.25 11V6.75A.75.75 0 0 1 12 6Z',
  globe:
    'M12 3.75a8.25 8.25 0 1 0 8.25 8.25A8.25 8.25 0 0 0 12 3.75Zm0 0c2.625 0 4.875 3.696 4.875 8.25S14.625 20.25 12 20.25 7.125 16.554 7.125 12 9.375 3.75 12 3.75Zm-8.25 8.25h16.5',
}

type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName
  className?: string
}

export default function Icon({ name, className = '', ...props }: IconProps) {
  const path = ICON_PATHS[name]
  const classes = ['h-5 w-5 text-sky-300', className].filter(Boolean).join(' ')
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={classes}
      {...props}
    >
      <path d={path} fill="currentColor" stroke="none" />
    </svg>
  )
}
